<lx-form-field
  class="date-of-birth-field"
  label="Date of birth"
  i18n-label
  [small]="true"
  [isValid]="isValid"
  [required]="required"
  [errorMessage]="errorMessage"
  [iconValidation]="true"
  lxDetectOutsideClick
  (clickOutside)="markTouchedOnOutsideFocus()"
  (focusin)="onInternalInteraction()"
>
  <p-inputMask
    class="date-of-birth-field__day"
    placeholder="DD"
    i18n-placeholder
    mask="99"
    [slotChar]="''"
    [autoClear]="false"
    [maxlength]="2"
    [(ngModel)]="day"
    (ngModelChange)="updateDateOfBirth()"
    (onFocus)="onInternalInteraction()"
  />
  <p-dropdown
    class="date-of-birth-field__month"
    placeholder="Month"
    i18n-placeholder
    optionLabel="name"
    optionValue="code"
    [style]="{ width: '100%' }"
    [options]="months"
    [(ngModel)]="month"
    [scrollHeight]="monthScrollHeight"
    [overlayOptions]="overlayOption"
    (onChange)="updateDateOfBirth()"
    (onFocus)="onInternalInteraction()"
  />
  <p-inputNumber
    class="date-of-birth-field__year"
    placeholder="YYYY"
    i18n-placeholder
    [maxlength]="4"
    [(ngModel)]="year"
    (onInput)="updateDateOfBirth()"
    [format]="false"
    (onFocus)="onInternalInteraction()"
  />
</lx-form-field>
